module.exports = __webpack_public_path__ + "media/categories/mecha-cbd20c90.png";